import React from "react";
import { Navigate } from "react-router-dom";

const RequireAuth = ({ children }) => {
  const token =
    localStorage.getItem("crm_jwt_token") ||
    sessionStorage.getItem("crm_jwt_token");
  //Need to validate the token
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default RequireAuth;
